import { useCallback } from 'react';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl';

export const useServicedeskSlaSkillPrompt = (): {
	formatCreateSlaSkillPrompt: (message: MessageDescriptor) => string;
	formatEditSlaSkillPrompt: (message: MessageDescriptor) => string;
	formatGetAllSlaSkillPrompt: (message: MessageDescriptor) => string;
} => {
	const { formatMessage } = useIntl();

	const formatCreateSlaSkillPrompt = useCallback(
		(message: MessageDescriptor): string => {
			return `/manage-sla ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	const formatEditSlaSkillPrompt = useCallback(
		(message: MessageDescriptor): string => {
			return `/manage-sla ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	const formatGetAllSlaSkillPrompt = useCallback(
		(message: MessageDescriptor): string => {
			return `/manage-sla ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	return { formatCreateSlaSkillPrompt, formatEditSlaSkillPrompt, formatGetAllSlaSkillPrompt };
};
